import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon, AddIcon } from '@chakra-ui/icons';

interface RoleActionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEdit: () => void;
  onAddChild?: () => void;
  onDelete: () => void;
  roleTitle: string;
}

export const RoleActionsModal = ({
  isOpen,
  onClose,
  onEdit,
  onAddChild,
  onDelete,
  roleTitle,
}: RoleActionsModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{roleTitle}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={3} align="stretch" my={4}>
            <Button leftIcon={<EditIcon />} onClick={onEdit}>
              Edit Role
            </Button>
            {onAddChild && (
              <Button leftIcon={<AddIcon />} onClick={onAddChild}>
                Add Role Below
              </Button>
            )}
            <Button
              leftIcon={<DeleteIcon />}
              colorScheme="red"
              onClick={onDelete}
            >
              Delete Role
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
